// extracted by mini-css-extract-plugin
export default {"LoadingPdfPage":"_LoadingPdfPage--x7sKt","FailedPdfPage":"_FailedPdfPage--wcRui","PdfPage":"_PdfPage--EVXCQ"};